// import {dingDingAppId} from '../api/systemSetting'
let wsHost = 'erp-beta.mulaitek.com'
let SITE_ID = '1279249251' // 友盟PV统计站点ID
let DD_APP_ID = 'dingoapjwr7qvo8uw7igqq' // 钉钉扫码登陆APP_ID
let DD_ADMINISTRATOR_ID = 'vpuxhnl' // 钉钉管理员ID 王飞

const wsProtocol = window.location.protocol === 'http:' ? 'ws:' : 'wss:'
const hostname = window.location.hostname

if (hostname) {
    if (['localhost', 'ad-beta.pblab.com'].indexOf(hostname) > -1) {
        wsHost = wsProtocol + '//erp-beta.mulaitek.com'
        SITE_ID = '1279249251'
        DD_APP_ID = 'dingoapjwr7qvo8uw7igqq'
    } else {
        wsHost = wsProtocol + '//yjoms.qianj.top'
        SITE_ID = '1279249000'
        DD_APP_ID = 'dingoalozws3pm6vr405p1'
    }
}
const WS_HOST = process.env.NODE_ENV === 'development' ? `${wsHost}/erp-scanner/ws/` : `${wsHost}/erp-scanner/ws/`
// dingDingAppId().then(res => {
//     console.warn(DD_APP_ID)
//     DD_APP_ID = res.model.appID || ''
// })
export default {WS_HOST, SITE_ID, DD_APP_ID, DD_ADMINISTRATOR_ID}

